/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { PolarisLoginForm } from '../PolarisLoginForm/PolarisLoginForm';
import * as yup from 'yup';
import * as S from './PolarisLoginComponent.styles';
import { FormTop } from '@exo/frontend-components-insurance';
import { PolarisLoginContainer } from '@exo/frontend-features-insurance-polaris-login-logic';
import { useIntl } from '@exo/frontend-common-i18n';

export const PolarisLoginComponent = ({ intlPrefix, loginEndpoint }: Props) => {
  const intl = useIntl(intlPrefix);
  const schema = yup.object().shape({
    username: yup
      .string()
      .required(
        intl.msg('LoginForm.validation.username', 'Please enter a valid user ID') as string
      ),
    password: yup
      .string()
      .required(
        intl.msg('LoginForm.validation.password', 'Please enter a valid password') as string
      )
  });

  return (
    <S.PolarisLoginComponentContainer>
      <S.FormTopWrapper>
        <FormTop title={intl.msg('LoginForm.registeredLabel', 'Registered users') as string}></FormTop>
      </S.FormTopWrapper>
      <PolarisLoginContainer
        loginEndpoint={loginEndpoint}
        render={args => <PolarisLoginForm {...args} schema={schema} intlPrefix={intlPrefix} />}
      ></PolarisLoginContainer>
    </S.PolarisLoginComponentContainer>
  );
};

type Props = { intlPrefix?: string; loginEndpoint: string };
